import { useEffect, useState } from 'react';
import { useQuery, gql } from '@apollo/client';

import { useAppDispatch } from '../../app/hooks';
import { showErrorSnackbar } from '../snackbar/snackbarSlice';
import { setProjects, setProject } from './projectSlice';
import { IUser } from '../../types/user';
import { IProjectAccess } from '../../types/user';
import { ICoopRate } from '../../types/project';
import { setPortal } from '../portal/portalSlice';

// General Info Projects
export const statusReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          name: '',
          code: '',
          color: '',
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

export const executorReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          name: '',
          email: '',
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

export const coopReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADDCOOPSTRUCTURE':
      return [
        ...state,
        {
          name: '',
          coopRates: [
            {
              type: '',
              days: 0,
              date: null,
              description: '',
              percentage: 1,
              fixedAmount: 0,
            },
          ],
        },
      ];
    case 'ADDCOOPRATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            coopRates: [
              ...state.coopRates,
              {
                type: '',
                days: 0,
                date: null,
                description: '',
                percentage: 1,
                fixedAmount: 0,
              },
            ],
          };
        } else return state;
      });
    case 'UPDATENAME':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            name: action.payload.value,
          };
        } else return state;
      });
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.structureIndex) {
          return {
            ...state,
            coopRates: state.coopRates.map((coopRate: ICoopRate, index: number) => {
              if (index === action.payload.index) {
                return {
                  ...coopRate,
                  [action.payload.field]: action.payload.value,
                };
              } else return coopRate;
            }),
          };
        } else return state;
      });
    case 'DELETECOOPRATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.structureIndex) {
          return {
            ...state,
            coopRates: state.coopRates.filter((coopRate: ICoopRate, index: number) => index !== action.payload.index),
          };
        } else return state;
      });
    case 'DELETECOOPSTRUCTURE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

export const adjustmentsReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          name: '',
          conditionField: '',
          conditions: [],
          type: '',
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

export const optionsReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          name: '',
          totalAvailable: 0,
          price: 0,
          type: 'residential',
          allowedUnits: [],
          rent: false,
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    default:
      throw new Error();
  }
};

export const depositsReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          name: '',
          deposits: [
            {
              name: 'Initial', // 1st Deposit, 2nd Deposit etc
              type: '', // Fixed or Percent
              amount: 0, // 5,000 or 2.5%
              dateType: '',
              daysDue: 0, // 30 days
              dueDate: new Date(), // Specific Date
            },
          ],
          default: false,
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    case 'COPY':
      return [...state, action.payload];
    default:
      throw new Error();
  }
};

export const supplementalDocumentsReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          aps: action.payload.aps,
          documents: action.payload.documents
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (!state.aps) {
          return {
            ...state,
            documents: action.payload.documents,
          };
        } else {
          if (state.aps && action.payload.aps && state.aps._id === action.payload.aps._id.toString()) {
            return {
              ...state,
              documents: action.payload.documents,
            };
          } else return state;
        }
      });
    default:
      throw new Error();
  }
};

export const accessAllowed = (user: IUser, projectId: string, restriction: string) => {
  let project = user.projectAccess.find((projectAccess: IProjectAccess) => {
    return projectAccess.project._id === projectId;
  });

  if (project?.access.includes(restriction)) {
    return true;
  } else return false;
};

export const useProjectsQuery = () => {
  const dispatch = useAppDispatch();

  return useQuery(GETPROJECTS, {
    onCompleted: (data) => {
      dispatch(setProjects(data.projectMany));
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });
};

// Used by DashboardOutlet/InPerson on every project navigation, so it only asks for fields those
// subtrees actually read off the redux project slice. Portal data (incl. the S3-signed media URLs)
// is intentionally omitted here - usePortalColorQuery already fetches and dispatches it in both call sites.
export const useProjectQuery = (id: string, project: string) => {
  const dispatch = useAppDispatch();

  return useQuery(GETPROJECT_LIGHT, {
    skip: project === id,
    variables: { _id: id },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.projectById.name) {
        document.title = `RDS Real Estate - ${data.projectById.name}`;
      } else {
        document.title = `RDS Real Estate`;
      }
      dispatch(setProject(data.projectById));
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });
};

// Used by the project settings editor (CreateProject), which needs every field, including
// portal media and the various put/get S3 URLs, so it keeps the full query.
//
// CreateProject's tabs (GeneralInfo, Portal, etc.) seed their local form state with
// `useState(project.someField)` - a one-time read on mount. Apollo's `onCompleted` runs in an
// effect that fires *after* the render where `loading` first flips to false, so if callers gated
// on `loading` alone, a tab could mount (and freeze its initial state) a tick before the
// `setProject` dispatch below actually lands, permanently missing full-only fields like `active`,
// `postRegistration`, or `imageGetUrl`. `ready` is flipped inside this same onCompleted callback,
// in the same batch as the dispatch, so callers gating on it are guaranteed redux already has the
// full data by the time they render.
export const useProjectSettingsQuery = (id: string, project: string) => {
  const dispatch = useAppDispatch();
  // Skipping (e.g. `id` is '' for a brand-new "create project" flow with nothing to fetch) means
  // onCompleted never fires, so ready must default to true in that case or callers gating on it
  // spin forever waiting for a request that's never sent.
  const skip = project === id;
  const [ready, setReady] = useState(skip);

  useEffect(() => {
    setReady(skip);
  }, [id, skip]);

  const query = useQuery(GETPROJECT_FULL, {
    skip,
    variables: { _id: id },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.projectById.name) {
        document.title = `RDS Real Estate - ${data.projectById.name}`;
      } else {
        document.title = `RDS Real Estate`;
      }
      dispatch(setProject(data.projectById));
      dispatch(setPortal(data.projectById.portal));
      setReady(true);
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });

  return { ...query, ready };
};

const GETPROJECTS = gql`
  query projectMany {
    projectMany {
      _id
      name
    }
  }
`;

// Fields actually read off the redux project slice by components under DashboardOutlet/InPerson
// (see projectHooks.ts useProjectQuery). No portal data and none of the S3-signed put/get URLs or
// other settings-editor-only fields that CreateProject needs - those live in GETPROJECT_FULL below.
const GETPROJECT_LIGHT = gql`
  query projectById($_id: MongoID!) {
    projectById(_id: $_id) {
      _id
      name
      email
      addresses {
        streetAddress
        city
        province
        postalCode
        country
      }
      hoursOfOperation {
        day
        open
        close
      }
      options {
        name
        totalAvailable
        price
        allowedUnits
        type
        rental
        rent
      }
      depositStructures {
        name
        deposits {
          name
          type
          amount
          daysDue
          dateType
          dueDate
        }
        default
      }
      mergeTemplates {
        name
        mergeTemplate {
          name
          _id
          totalPages
        }
        apsTemplates {
          name
          apsTemplate {
            type
            _id
            name
          }
          pageNumber
          attachToAps
        }
      }
      status {
        name
        code
        color
        type
        category
      }
      executors {
        name
        email
        cc
        ccAll
        ccNotice
      }
      mortgageLimit
      defaultZeroValue
      adjustments {
        name
        type
        conditionField
        conditions {
          amount
          value
          values
          condition
        }
      }
      commissionIncludeOptions
      logoGetUrl
      leasing
      netHst
      coopStructures {
        name
        coopRates {
          type
          days
          date
          description
          percentage
          fixedAmount
        }
      }
      firstTentativeOccupancy
      finalTentativeOccupancy
      firmOccupancy
      outsideOccupancy
      acknowledgement
      decorModels {
        modelType
        allowed
      }
    }
  }
`;

const GETPROJECT_FULL = gql`
  query projectById($_id: MongoID!) {
    projectById(_id: $_id) {
      _id
      name
      developerName
      email
      docusignEmail
      trackingPhone
      salesTrackingPhone
      addresses {
        streetAddress
        city
        province
        postalCode
        country
      }
      hoursOfOperation {
        day
        open
        close
      }
      options {
        name
        totalAvailable
        price
        allowedUnits
        type
        rental
        rent
      }
      depositStructures {
        name
        deposits {
          name
          type
          amount
          daysDue
          dateType
          dueDate
        }
        default
      }
      mergeTemplates {
        name
        mergeTemplate {
          name
          _id
          totalPages
        }
        apsTemplates {
          name
          apsTemplate {
            type
            _id
            name
          }
          pageNumber
          attachToAps
        }
      }
      status {
        name
        code
        color
        type
        category
      }
      executors {
        name
        email
        cc
        ccAll
        ccNotice
      }
      mortgageLimit
      mortgageMinDay
      hideOccupancy
      defaultZeroValue
      lawyer
      tagLine
      salesOffice
      adjustments {
        name
        type
        conditionField
        conditions {
          amount
          value
          values
          condition
        }
      }
      commissionIncludeOptions
      logoGetUrl
      logoPutUrl
      imageGetUrl
      imagePutUrl
      developerLogoGetUrl
      developerLogoPutUrl
      partnerLogoGetUrl
      partnerLogoPutUrl
      leaseCc {
        _id
        email
        fullName
      }
      letter
      leasing
      coopStructures {
        name
        coopRates {
          type
          days
          date
          description
          percentage
          fixedAmount
        }
      }
      firstTentativeOccupancy
      finalTentativeOccupancy
      firmOccupancy
      outsideOccupancy
      active
      acknowledgement
      executionDeposit
      automatedReminders
      postRegistration
      netHst
      tags
      acknowledgement
      supplementals {
        aps {
          _id
          name
        }
        documents
      }
      decorModels {
        modelType
        allowed
      }
      portal {
        _id
        active
        vipActive
        showHotlist
        showFloorPlans
        sortHotlist
        showCustom
        createWorksheets
        showOptionsPrice
        showUnitTypes
        showOptions
        password
        information
        promo
        renderings {
          _id
          getUrl
          name
        }
        photos {
          _id
          getUrl
          name
        }
        pdfs {
          _id
          getUrl
          name
        }
        logos {
          _id
          name
          getUrl
        }
        aerialPhotos {
          _id
          name
          getUrl
        }
        bRoll {
          _id
          name
          getUrl
        }
        officialSite
        instaUrl
        facebookUrl
        primaryColor
        secondaryColor
        brochure
        brochureGetUrl
        brochurePutUrl
        subText
        videos {
          name
          getUrl
        }
        project {
          _id
        }
      }
      combinedProjects {
        _id
        name
      }
    }
  }
`;
